import * as Yup from "yup";

const ruleSchema = Yup.object().shape({
  client_id: Yup.number()
    .required("Selecione a operação")
    .test(
      "selected",
      "Selecione a operação",
      (value) => value != null && value !== 0
    ),
  substitutions: Yup.array()
    .min(1, "Insira ao menos um desmembramento")
    .required("Insira ao menos um desmembramento"),
});

export const productRulesSchema = Yup.object().shape({
  product: Yup.object().nullable(),
  synonyms: Yup.string().required("Insira ao menos um sinônimo"),
  rules: Yup.array().of(ruleSchema).min(1, "Adicione ao menos uma regra"),
});
